<template>
  <div class="setPersonnel">
    <div class="menuCont">
      <my-tree ref="myTree"
               :treeData="treeData"
               :treeLoading="treeLoading"
               :treeToolBar="treeToolBar"
               :defaultProps="defaultProps"
               :departTotal="departTotal"
               :title="title"
               :nodeKey="'val'"
               @handleTreeNodeClick="handleTreeNodeClick"
               :default-expand-all="true"
               :treeSearchBar="false">
      </my-tree>
    </div>
    <div class="formCont">
      <el-form :model="resign_remark"
               ref="resign_remark"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'resign_remark'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注内容">
              <template v-for="(item, index) in resign_remark">
                <el-input :key="index"
                          clearable
                          placeholder="请输入备注内容"
                          maxlength="20"
                          size="small"
                          v-model="resign_remark[index]">
                </el-input>
                <el-button :key="index"
                           icon="el-icon-minus"
                           type="text"
                           size="mini"
                           style="margin-left:10px;color:#ff0000"
                           @click="minusRemarkItem(index)"></el-button>
              </template>

              <el-button icon="el-icon-plus"
                         type="text"
                         size="mini"
                         style="margin-left:10px"
                         @click="addRemarkItem"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="target_number"
               ref="target_number"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'target_number'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="当前年份">
              {{ this.nowYear }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="目标人数">
              <el-input clearable
                        placeholder="请输入目标人数"
                        maxlength="20"
                        size="small"
                        v-model="target_number">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="attendance"
               ref="attendance"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'attendance'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="上班时间">
              <el-time-picker v-model="attendance.time1"
                              placeholder="请输入上班时间"
                              value-format="HH:mm"
                              format="HH:mm"
                              size="small">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="下班时间">
              <el-time-picker v-model="attendance.time2"
                              placeholder="请输入下班时间"
                              value-format="HH:mm"
                              format="HH:mm"
                              size="small">
              </el-time-picker>
            </el-form-item>
            <el-form-item label="加班时间">
              <el-time-picker v-model="attendance.time3"
                              placeholder="请输入加班时间"
                              value-format="HH:mm"
                              format="HH:mm"
                              size="small">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="turn_effect_remind"
               ref="turn_effect_remind"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'turn_effect_remind'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="预警天数">
              <el-input clearable
                        placeholder="请输入预警天数"
                        maxlength="20"
                        size="small"
                        v-model="turn_effect_remind">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="color:#ff0000"
                          label=" ">
              转正时间前多少天系统通知提示！
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="attendance_confirm"
               ref="attendance_confirm"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'attendance_confirm'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="每月日期"
                          :rules="[
                                {
                                    type: 'number',
                                    required: true,
                                    min: 1,
                                    max: 31,
                                    message: '日期可输入值为1 - 31',
                                    trigger: 'blur'
                                }
                            ]"
                          prop="date">
              <el-input clearable
                        placeholder="请输入每月日期"
                        prefix-icon="el-icon-date"
                        size="small"
                        maxlength="2"
                        v-model.number="attendance_confirm.date">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="截止时间">
              <el-time-picker v-model="attendance_confirm.time"
                              placeholder="请输入截止时间"
                              value-format="HH:mm"
                              format="HH:mm"
                              size="small">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="color:#ff0000"
                          label=" ">
              {{ nowYear }}/{{ nextMonth }}/{{ showDay }}&nbsp;{{
                                attendance_confirm.time
                            }}截止确认考勤!
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="workdays_2020"
               ref="workdays_2020"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'workdays_2020'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-col :span="24">
              <el-form-item label="当期年份">
                {{ this.nowYear }}
              </el-form-item>
            </el-col>
            <el-form-item v-for="(item, index) in workdays_2020"
                          :key="index"
                          size="small"
                          :label="`${item.month}月`">
              <el-input clearable
                        :placeholder="`请输入${item.month}月上班天数`"
                        maxlength="20"
                        size="small"
                        v-model="item.value">
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="early_warn_day"
               ref="early_warn_day"
               label-width="100px"
               :inline="true"
               v-show="formVal == 'early_warn_day'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="当前年份">
              {{ this.nowYear }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="提前预警天数">
              <el-input clearable
                        placeholder="请输入提前预警天数"
                        maxlength="20"
                        size="small"
                        v-model="early_warn_day">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:left;margin:80px 0 0 100px;">
        <el-button @click="configSetting"
                   type="primary"
                   size="small">保 存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import Tree from "@/comon/components/treeChange";
export default {
  data () {
    return {
      treeData: [
        { name: "补勤备注", val: "resign_remark" },
        { name: "目标人数", val: "target_number" },
        { name: "上班设置", val: "attendance" },
        { name: "转正预警设置", val: "turn_effect_remind" },
        { name: "考勤确认设置", val: "attendance_confirm" },
        { name: "考勤上班设置", val: "workdays_2020" },
        { name: "提前预警天数", val: "early_warn_day" }
      ],
      treeLoading: false,
      treeToolBar: false,
      defaultProps: {
        children: "child",
        label: "name"
      },
      title: "人事设置",
      formVal: "resign_remark",

      nowYear: new Date().getFullYear(),

      resign_remark: [""], // 补勤备注
      target_number: "", // 目标人数
      early_warn_day: "", // 提前预警天数
      attendance: {
        time1: "",
        time2: "",
        time3: ""
      }, // 上班时间
      //   attendance_offTime: '', // 下班时间
      //   attendance_overTime: '',// 加班时间
      turn_effect_remind: "", // 预警天数
      attendance_confirm: {
        date: "",
        time: ""
      }, // 每月日期
      workdays_2020: [
        { month: "1", value: "0" },
        { month: "2", value: "0" },
        { month: "3", value: "0" },
        { month: "4", value: "0" },
        { month: "5", value: "0" },
        { month: "6", value: "0" },
        { month: "7", value: "0" },
        { month: "8", value: "0" },
        { month: "9", value: "0" },
        { month: "10", value: "0" },
        { month: "11", value: "0" },
        { month: "12", value: "0" }
      ] //考勤上班设置
    };
  },
  methods: {
    handleTreeNodeClick (val) {
      this.formVal = val.val;
      this.getConfigGconf();
    },
    getConfigGconf () {
      oaApi.gconf(
        {
          name: this.formVal
        },
        "get"
      ).then(res => {
        if (res) {
          this[this.formVal] = res.data;
        }
      });
    },
    configSetting () {
      if (this.formVal == "early_warn_day") {
        if (this.early_warn_day > 30) {
          this.$message.warning("天数不能大于30天");
          return;
        }
      }
      oaApi.configSetting(
        {
          name: this.formVal,
          value: this[this.formVal]
        },
        "post"
      ).then(res => {
        if (res) {
          this.$message.success("保存成功");
          this.getConfigGconf();
        }
      });
    },
    addRemarkItem () {
      this.resign_remark.push(" ");
    },
    minusRemarkItem (index) {
      this.resign_remark.splice(index, 1);
    }
  },
  created () {
    this.getConfigGconf();
  },
  mounted () {
    this.$refs.myTree.$refs.tree.setCurrentKey(this.formVal);
  },
  components: {
    "my-tree": Tree
  },
  computed: {
    nowYear () {
      let date = new Date();
      return date.getFullYear();
    },
    nextMonth () {
      let date = new Date();
      return ("0" + (date.getMonth() + 1)).slice(-2);
    },
    showDay () {
      return ("0" + this.attendance_confirm.date).slice(-2);
    }
  }
};
</script>

<style lang="scss">
.setPersonnel {
    width: 100%;
    min-height: 100%;
    background: #fff;
    display: flex;
    .menuCont {
        width: 250px;
        // border-right: 1px #eee solid;
        // padding: 0 20px;
        box-sizing: border-box;
        height: 100%;
    }
    .formCont {
        width: calc(100% - 250px);
        padding: 20px;
        border-left: 1px #ddd solid;
        .el-col-24 {
            text-align: left;
        }
        .el-form-item__content {
            width: 700px;
        }
        .el-input {
            width: 500px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .el-input-group__append {
            padding: 0 5px;
        }
    }
}
</style>
